import React from "react";

const KnowledgeV2 = () => {
  return (
    <div id="knowledge" className="services">
      <h1>knowledge</h1>
      <div class="knowledge-container">
        <div class="knowledge-card">
          <div class="knowledge-box">
            <div class="knowledge-content">
              <h2>01</h2>
              <h3>Manual Testing</h3>
              <p>
                I'm making E2E test and product configuratin in Agile Team. Now
                i'm execution test cases, log defects by using Jira. Manage
                schedule to complete all testing for release deadlines.
              </p>
            </div>
          </div>
        </div>
        <div class="knowledge-card">
          <div class="knowledge-box">
            <div class="knowledge-content">
              <h2>02</h2>
              <h3>Java Swing</h3>
              <p>
                I have launched my first Udemy course which name is "Java Swing
                İle A'dan Z'ye Gelişmiş Arayüz Tasarımı". You can join my
                course.
                <a
                  href="https://www.udemy.com/course/java-swing-ile-adan-zye-gelismis-arayuz-tasarm/?couponCode=NETLIFY-JAVA"
                  target="_blank"
                  rel="noreferrer"
                >
                  Click For Course
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="knowledge-card">
          <div class="knowledge-box">
            <div class="knowledge-content">
              <h2>03</h2>
              <h3>Selenium Webdriver</h3>
              <p>
              I have launched my second Udemy course which is all about starter level of Selenium Webdriver. You can join my "Selenium Webdriver Education with Java" course
              <a
                  href="https://www.udemy.com/course/java-ile-selenium-webdriver-baslangc-egitimi/?referralCode=BAFDFC4693E816A2E591"
                  target="_blank"
                  rel="noreferrer"
                >
                  Click For Course
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="knowledge-card">
          <div class="knowledge-box">
            <div class="knowledge-content">
              <h2>04</h2>
              <h3>Web Development</h3>
              <p>
                I'm learning web development with using javascript, HTML5, CSS3,
                Nodejs. I developed this site to learn ReactJs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeV2;
